<template>
	<el-input ref="inputRef" :model-value="inputVal" :placeholder="placeholder" clearable @click="open"
		@clear="clearHandle" @focus="isFocused = true" @blur="isFocused = false" @mouseenter="isHovered = true"
		@mouseleave="isHovered = false" v-bind="attrs">
		<template #suffix>
			<pi-icon v-if="!inputVal || (!isFocused && !isHovered)" class="icon" icon="pi-icon-choice" @click="open" />
		</template>
	</el-input>
	<el-dialog :title="title" v-model="visible" :width="800" destroy-on-close :close-on-click-modal="false" top="8vh"
		:append-to-body="true">
		<div v-loading="loading">
			<div class="pi-table-select__header">
				<slot name="header" :form="formData" :submit="formSubmit"></slot>
			</div>
			<el-table ref="tableRef" :data="tableData" :height="480" :highlight-current-row="!multiple"
				@row-click="click" @select="select" @select-all="selectAll">
				<el-table-column v-if="multiple" type="selection" width="45"></el-table-column>
				<el-table-column v-else type="index" width="45">
					<template #default="scope"><span>{{ scope.$index + (currentPage - 1) * pageSize + 1 }}</span>
					</template>
				</el-table-column>
				<slot></slot>
			</el-table>
			<div class="pi-table-select__page" v-if="!hidePagination">
				<el-pagination size="small" background layout="prev, pager, next" :total="total" :page-size="pageSize"
					v-model:currentPage="formData.page" @current-change="reload"></el-pagination>
			</div>
		</div>
		<template #footer v-if="multiple">
			<el-button @click="visible = false">取 消</el-button>
			<el-button @click="confirm()">确 定</el-button>
		</template>
	</el-dialog>
</template>

<script setup>
import config from "@/config/select"
import { ref, onMounted, nextTick, useAttrs } from "vue"

defineExpose({
	open
})

const attrs = useAttrs()
const emit = defineEmits(["update:modelValue", "change"])

const props = defineProps({
	modelValue: {},
	title: { type: String, default: '请选择' },
	api: {
		type: Function, default: () => {
		}
	},
	limit: { type: Number, default: 0 },
	multiple: { type: Boolean, default: false },
	params: {
		type: Object, default: () => {
		}
	},
	props: {
		type: Object, default: () => {
		}
	},
	placeholder: { type: String, default: "请选择" },
	showValue: { type: String, default: "" },
	hidePagination: { type: Boolean, default: false },
})
const tableRef = ref(null)

let loading = ref(false)
let visible = ref(false)
let isFocused = ref(false)
let isHovered = ref(false)
let tableData = ref([])
let pageSize = ref(config.pageSize)
let currentPage = ref(1)
let total = ref(0)
let formData = ref({})
let checkData = ref([])
let defaultProps = ref({
	label: config.props.label,
	value: config.props.value,
	page: config.request.page,
	pageSize: config.request.pageSize,
	keyword: config.request.keyword,
	fields: []
})
let inputVal = ref("")

onMounted(() => {
	defaultProps.value = Object.assign(defaultProps.value, props.props)
	inputVal.value = props.showValue
})

function autoLabel() {
	if (checkData.value.length > 0) {
		if (props.multiple) {
			if (checkData.value.length > 4) {
				inputVal.value = `已选择${checkData.value.length}项`
			} else {
				inputVal.value = checkData.value.map(s => s[defaultProps.value.label]).filter(Boolean).join('、')
			}
			return;
		}
		inputVal.value = checkData.value[0][defaultProps.value.label];
		return;
	}
	inputVal.value = ""
}

//显示
function open() {
	visible.value = true
	formData.value = {}
	getData()
}

async function getData() {
	var reqData = {
		[config.request.page]: currentPage.value,
		[config.request.pageSize]: pageSize.value,
	}
	Object.assign(reqData, props.params, formData.value)
	const res = await props.api(reqData)
	tableData.value = res.data
	total.value = res.count
	initCheck()
}

function confirm() {
	visible.value = false
	emit('change', checkData.value);
	autoLabel()
}

function formSubmit() {
	currentPage.value = 1
	getData()
}

//分页刷新表格
function reload() {
	getData()
}

//表格勾选事件
function select(rows, row) {
	var isSelect = rows.length && rows.indexOf(row) !== -1
	if (isSelect) {
		checkData.value.push(row)
	} else {
		checkData.value.splice(checkData.value.findIndex(item => item[defaultProps.value.value] === row[defaultProps.value.value]), 1)
	}
	autoLabel()
}

//表格全选事件
function selectAll(rows) {
	var isAllSelect = rows.length > 0
	if (isAllSelect) {
		rows.forEach(row => {
			var isHas = false
			isHas = checkData.value.find(item => item[defaultProps.value.value] === row[defaultProps.value.value])
			if (!isHas) {
				checkData.value.push(row)
			}
		})
	} else {
		tableData.value.forEach(row => {
			var isHas = false
			isHas = checkData.value.find(item => item[defaultProps.value.value] === row[defaultProps.value.value])
			if (isHas) {
				checkData.value.splice(checkData.value.findIndex(item => item[defaultProps.value.value] === row[defaultProps.value.value]), 1)
			}
		})
	}
}

function click(row) {
	if (!props.multiple) {
		visible.value = false
		checkData.value = [row]
		emit('change', checkData.value)
		emit('update:modelValue', row[defaultProps.value.value])
		autoLabel()
		return
	}
	var isSelect = checkData.value.length && checkData.value.indexOf(row) !== -1
	tableRef.value.toggleRowSelection(row)
	if (!isSelect) {
		checkData.value.push(row)
	} else {
		checkData.value.splice(checkData.value.findIndex(item => item[defaultProps.value.value] === row[defaultProps.value.value]), 1)
	}
}

function initCheck() {
	if (!props.multiple) return;
	nextTick(() => {
		tableData.value.forEach((row) => {
			var isHas = false
			isHas = checkData.value.find(item => item[defaultProps.value.value] === row[defaultProps.value.value])
			if (isHas) {
				tableRef.value.toggleRowSelection(row, true)
			}
		});
	})
}

function clearHandle() {
	checkData.value = []
	autoLabel()
	emit('update:modelValue')
	emit('change', checkData.value)
}
</script>

<style scoped>
.pi-table-select__table {
	padding: 12px;
}

.pi-table-select__page {
	padding-top: 12px;
}

.icon {
	cursor: pointer;
	width: 100%;
	height: 100%;
}

:deep(.pi-table-select__header) {
	display: flex;
	gap: 10px
}
</style>
